import { render, staticRenderFns } from "./Wonder2.vue?vue&type=template&id=3ff95564&"
import script from "./Wonder2.vue?vue&type=script&lang=ts&"
export * from "./Wonder2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports